'use strict';

import React from 'react'

import Link from '@Pure/Link'

import { formatNum } from '@root/utility'

export default function ServiceRow ({ data, blank=true, fields, ...props })
{
	const href = '/gestion-des-services/' + data.id;

	const link =
	(
		<Link href={ href } className="u-link-only">
			<span className="u-readers-only">Ouvrir</span>
		</Link>
	);

	return (
		<div className="c-dashboard__row">

			<div className="c-dashboard__cell Service-title">

				<div className="c-dashboard__long-text">
					{ data.title }
				</div>

				{ link }

			</div>

			<div className="c-dashboard__cell Service-accounting_code">
				{ data.accounting_code }

				{ link }
			</div>

			<div className="c-dashboard__cell Service-amount">
				{ formatNum(data.amount, '0,0[.]00') }€

				{ link }
			</div>

		</div>
	);
}